/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ICON_spring': {
    width: 31,
    height: 24,
    viewBox: '0 0 31 24',
    data: '<path pid="0" d="M13.5 13.5c-.5 0-1 .5-1 1s.5 1 1.5 1 2.5-.646 2.5-2.5-1.055-3.5-3-3.5-4 1.5-4 4.5 2.5 4.5 5.5 4.5c3.896 0 7.5-3.075 7.5-7 0-6.35-4.285-11-10.588-11C5.61.5.5 5.647.5 11.997c0 6.349 5.11 11.496 11.412 11.496C24.65 23.796 26 14.5 31 14.5"/>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/ICON_spring.js